"use strict";

import React from 'react';
import OrderLineItem from "./OrderLineItem";

const OrderLineItems = ({isTopsOrder=false, lineItems=[]}) => {
    const key = isTopsOrder ? 'id' : 'li_id';
    if(lineItems.length){
        return (
            <>
                {lineItems.map( (item, index) =>
                    <OrderLineItem key={item[key]} item={item} />
                )}
            </>
        );
    }
    return null;
};

export default OrderLineItems;